import type { FC, ReactElement } from "react";

import { FramerTooltip } from "@ryde/controls";
import { BulkGridSelectionModeEnum, TOOLTIP_DELAY_BUTTONS } from "@ryde/shared";

import { BulkGridSelectionModeGlyph } from "./bulk-grid-selection-mode-glyph";

interface IBulkGridSelectionModeIndicatorProps {
  mode: BulkGridSelectionModeEnum;
  tooltip: string;
}

/** Current mode icon next to the checkbox (indicator only). */
export const BulkGridSelectionModeIndicator: FC<
  IBulkGridSelectionModeIndicatorProps
> = ({ mode, tooltip }): ReactElement => {
  return (
    <FramerTooltip content={tooltip} mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}>
      <span className="bulk-grid-selection__mode-indicator" aria-hidden>
        <BulkGridSelectionModeGlyph mode={mode} />
      </span>
    </FramerTooltip>
  );
};
